import { motion } from 'framer-motion'
import { Users, Building, Star, TrendingUp } from 'lucide-react'

const StatsSection = () => {
  const stats = [
    {
      icon: Building,
      value: '150+',
      label: 'Escolas Atendidas',
      description: 'Escolas de natação confiam na nossa solução'
    },
    {
      icon: Users,
      value: '15.000+',
      label: 'Alunos Ativos',
      description: 'Alunos usando nossos apps diariamente'
    },
    {
      icon: Star,
      value: '98%',
      label: 'Satisfação',
      description: 'Taxa de satisfação dos nossos clientes'
    },
    {
      icon: TrendingUp,
      value: '40%',
      label: 'Aumento na Receita',
      description: 'Média de aumento na receita das escolas'
    }
  ]

  return (
    <section className="py-20 bg-primary-600 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Números que comprovam nossa eficiência
          </h2>
                      <p className="text-xl text-primary-100 max-w-3xl mx-auto">
              Veja como nossa solução está transformando escolas de natação 
              em todo o Brasil.
            </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center group"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 group-hover:-translate-y-2">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-2xl mb-6 group-hover:bg-white/30 transition-colors">
                  <stat.icon className="h-8 w-8" />
                </div>
                
                <div className="text-4xl lg:text-5xl font-bold mb-2">
                  {stat.value}
                </div>
                
                <div className="text-lg font-semibold mb-2">
                  {stat.label}
                </div>
                
                <div className="text-primary-100 text-sm">
                  {stat.description}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default StatsSection
